import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useResidentEnvironments } from '~/hooks/environment/useResidentEnvironments';
import { selectedROIState } from '~/state/atoms/structureSet/roiAtoms';

/**
 * Publishes the selected structure onto every resident Environment, so each
 * contour layer draws the selection at full weight and a mode that
 * spotlights the selection has one to spotlight. The Environment ignores a
 * number its structure set does not hold, and a repeated selection is a
 * no-op there, so the fan-out is idempotent. Mount once in an always-rendered
 * viewer component that outlives the grid's tiles.
 */
export function useStructureSelectionBridge(): void {
    const environments = useResidentEnvironments();
    const selectedRoiId = useRecoilValue(selectedROIState);

    useEffect(() => {
        for (const environment of environments) {
            environment.setSelectedRoiById(selectedRoiId);
        }
    }, [environments, selectedRoiId]);
}
